import React, { useEffect, useState } from 'react';
import styles from './TextSwitch.module.css';
import classNames from 'classnames';

const TextSwitch = ({ selected, options, onChange }) => {
  const [selectedValue, setSelectedValue] = useState(() => selected);

  useEffect(() => {
    if (selected) {
      setSelectedValue(selected);
    }
  }, [selected]);

  const handleOptionClick = (value) => {
    onChange(value);
  };

  return (
    <div className={styles.modeSwitcher}>
      {options.map((option) => (
        <button
          key={option.value}
          className={classNames(styles.option, { [styles.active]: selectedValue === option.value })}
          onClick={() => handleOptionClick(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default TextSwitch;
